
export const categories = [
    "Nursing",
    "Midwifery",
    "Medical Laboratory Science",
    "Dentistry",
    "Pharmacy",
    "Physiotherapy",
    "Public Health",
    "Anatomy and Physiology",
    "Research and Biostatistics",
    "Medical Imaging Technology"
]


export const categoriesData = [
    {
        caption: "Nursing",
        image: "/media/nurse-drip.jpg",
        category: "Nursing",
    },
    {
        caption: "Medical Lab. Science",
        image: "/media/mlt.jpeg",
        category: "Medical Laboratory Science"
    },
    {
        caption: "Midwifery",
        image: "/media/midwifes.jpeg",
        category: "Midwifery"
    },
    {
        caption: "Radiology",
        image: "/media/radiology.jpeg",
        category: "Radiology"
    },
    {
        caption: "Pharmacy",
        image: "/media/pharmacy.jpg",
        category: "Pharmacy"
    },
    {
        caption: "Dentistry",
        image: "/media/dentist.jpeg",
        category: "Dentistry"
    },
    {
        caption: "Public health",
        image: "/media/pub-health.jpeg",
        category: "Public Health"
    },
    {
        caption: "Physiotherapy",
        image: "/media/phisio.jpeg",
        category: "Physiotherapy"
    }
]

export const buttonsData = [
    {
        caption: "Pharmacy",
        icon: "pharmacy.svg",
        background: "/media/pharmacy.jpg"
    },
    {
        caption: "Nursing",
        icon: "nursing.svg",
        background: '/media/nurse-drip.jpg'
    },
    {
        caption: "Midwifery",
        icon: "midwifery.svg",
        background: "/media/midwifes.jpg"
    },
    {
        caption: "Physiotherapy",
        icon: "physiotherapy.svg",
        background: "/media/phisio.jpg"
    },
    {
        caption: "Medical Laboratory Technology",
        icon: "laboratory.svg",
        background: "/media/mlt.jpg"
    },
    {
        caption: "Dentistry",
        icon: "dentistry.svg",
        background: "/media/dentist.jpg"
    },
    {
        caption: "Public Health",
        icon: "public_health.svg",
        background: "/media/pub-health.jpg"
    },
    {
        caption: "Anatomy and Physiology",
        icon: "anatomy.svg",
        background: "/media/anatomy.jpg"
    },
    {
        caption: "Research and Biostatistics",
        icon: "biostatistics.svg",
        background: "/media/biostats.jpg"
    },
    {
        caption: "Medical Imaging Technology",
        icon: "x-ray.svg",
        background: "/media/med-img-tech.jpg"
    }
]


export const questionMock = [
    {
        question: "Which of the following drugs is a beta-blocker used primarily for cardiovascular conditions?",
        options: [
            "Lisinopril",
            "Metoprolol",
            "Furosemide",
            "Amlodipine"
        ],
        answer: 2
    },
    {
        question: "What is the mechanism of action of ACE inhibitors like enalapril?",
        options: [
            "Blockade of beta-adrenergic receptors",
            "Inhibition of angiotensin-converting enzyme",
            "Calcium channel blockade",
            "Inhibition of HMG-CoA reductase"
        ],
        answer: 2
    },
    {
        question: "Which antibiotic is known for causing photosensitivity as a side effect?",
        options: [
            "Amoxicillin",
            "Ciprofloxacin",
            "Tetracycline",
            "Ceftriaxone"
        ],
        answer: 3
    },
    {
        question: "Which of the following drugs is used in the management of type 2 diabetes and works by increasing insulin sensitivity?",
        options: [
            "Metformin",
            "Tolbutamide",
            "Insulin glargine",
            "Glipizide"
        ],
        answer: 1
    },
    {
        question: "What is the primary therapeutic use of the medication levothyroxine?",
        options: [
            "Asthma management",
            "Hyperthyroidism treatment",
            "Hypothyroidism treatment",
            "Anemia management"
        ],
        answer: 3
    },
    {
        question: "Which of the following drugs is a beta-blocker used primarily for cardiovascular conditions?",
        options: [
            "Lisinopril",
            "Metoprolol",
            "Furosemide",
            "Amlodipine"
        ],
        answer: 2
    },
    {
        question: "What is the mechanism of action of ACE inhibitors like enalapril?",
        options: [
            "Blockade of beta-adrenergic receptors",
            "Inhibition of angiotensin-converting enzyme",
            "Calcium channel blockade",
            "Inhibition of HMG-CoA reductase"
        ],
        answer: 2
    },
    {
        question: "Which antibiotic is known for causing photosensitivity as a side effect?",
        options: [
            "Amoxicillin",
            "Ciprofloxacin",
            "Tetracycline",
            "Ceftriaxone"
        ],
        answer: 3
    },
    {
        question: "Which of the following drugs is used in the management of type 2 diabetes and works by increasing insulin sensitivity?",
        options: [
            "Metformin",
            "Tolbutamide",
            "Insulin glargine",
            "Glipizide"
        ],
        answer: 1
    },
    {
        question: "What is the primary therapeutic use of the medication levothyroxine?",
        options: [
            "Asthma management",
            "Hyperthyroidism treatment",
            "Hypothyroidism treatment",
            "Anemia management"
        ],
        answer: 3
    },
    {
        question: "Which of the following drugs is a beta-blocker used primarily for cardiovascular conditions?",
        options: [
            "Lisinopril",
            "Metoprolol",
            "Furosemide",
            "Amlodipine"
        ],
        answer: 2
    },
    {
        question: "What is the mechanism of action of ACE inhibitors like enalapril?",
        options: [
            "Blockade of beta-adrenergic receptors",
            "Inhibition of angiotensin-converting enzyme",
            "Calcium channel blockade",
            "Inhibition of HMG-CoA reductase"
        ],
        answer: 2
    },
    {
        question: "Which antibiotic is known for causing photosensitivity as a side effect?",
        options: [
            "Amoxicillin",
            "Ciprofloxacin",
            "Tetracycline",
            "Ceftriaxone"
        ],
        answer: 3
    },
    {
        question: "Which of the following drugs is used in the management of type 2 diabetes and works by increasing insulin sensitivity?",
        options: [
            "Metformin",
            "Tolbutamide",
            "Insulin glargine",
            "Glipizide"
        ],
        answer: 1
    },
    {
        question: "What is the primary therapeutic use of the medication levothyroxine?",
        options: [
            "Asthma management",
            "Hyperthyroidism treatment",
            "Hypothyroidism treatment",
            "Anemia management"
        ],
        answer: 3
    }

]

export const yearsList = () => {
    const years = [];
    for (let n = 1990; n < 2035; n++) {
        years.push(n);
    }

    return years;
}